import { createContext } from "react";

export type LayerContextType = {
  type: "content" | "excursion";
  slug?: string;
};

export const LayerContext = createContext<LayerContextType>({
  type: "content",
  slug: undefined,
});
